import type { Dayjs } from 'dayjs';

/**
 * Whether the Revenue / Expenses / Margin cards should show their sparkline.
 *
 * On the Financial tab a one-month range is a single billing period, and these
 * facilities bill monthly — nearly every charge is dated the 1st. Bucketed weekly
 * that leaves one populated bucket and four empty ones, so there is no pair of
 * adjacent points to draw a line between and the chart renders as nothing (20 of 27
 * facilities on staging). Anna's call (ST #137, comment 384) is to drop the
 * sparkline for a single month rather than show an empty frame, and keep it from
 * two months upwards where every bucket has data.
 */
export const monthsSpanned = (dateRange: {
  from: Dayjs;
  to: Dayjs;
}): number => {
  // Calendar months, not elapsed ones. The Financial tab's ranges run to the end of
  // a month, so Jun 1 – Jul 31 is two months even though it is only ~1.97 elapsed —
  // a fractional comparison would wrongly hide the sparkline for a real 2-month range.
  const { from, to } = dateRange;

  return (to.year() - from.year()) * 12 + (to.month() - from.month()) + 1;
};

export const shouldShowSparkline = (dateRange: {
  from: Dayjs;
  to: Dayjs;
}): boolean => monthsSpanned(dateRange) >= 2;
